import { render, staticRenderFns } from "./CustomProductModal.vue?vue&type=template&id=1a6dea36&scoped=true&lang=html&"
import script from "./CustomProductModal.vue?vue&type=script&lang=js&"
export * from "./CustomProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6dea36",
  null
  
)

export default component.exports